<ion-app>

  <ion-header class="page-header">

    <ion-toolbar color="primary">

      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>

      <ion-title>
        Gestionar Publicidad
      </ion-title>

      <ion-buttons slot="end">

        <ion-button *ngIf="selectedStatus === 'active' || selectedStatus === 'inactive'" [disabled]="!!search.trim()"
          (click)="toggleReorder()" fill="clear">

          <ion-icon slot="icon-only" [name]="canReOrder ? 'checkmark-outline' : 'swap-vertical-outline'">
          </ion-icon>

        </ion-button>

      </ion-buttons>

    </ion-toolbar>


    <!-- BUSCADOR -->

    <ion-toolbar color="primary" class="search-toolbar">

      <ion-searchbar [(ngModel)]="search" placeholder="Buscar publicidad..." mode="md" debounce="150" animated="true"
        showCancelButton="focus" (ionInput)="onSearch($event)" (ionClear)="clearSearch()" (ionCancel)="clearSearch()">
      </ion-searchbar>

    </ion-toolbar>


    <!-- SEGMENTO -->

    <ion-toolbar color="primary" class="status-toolbar">

      <ion-segment [(ngModel)]="selectedStatus" (ionChange)="changeStatus()" mode="md">

        <ion-segment-button value="active">

          <ion-label>

            Activas

            <ion-badge color="success">

              {{ activeCount }}

            </ion-badge>

          </ion-label>

        </ion-segment-button>


        <ion-segment-button value="inactive">

          <ion-label>

            Inactivas

            <ion-badge color="medium">

              {{ inactiveCount }}

            </ion-badge>

          </ion-label>

        </ion-segment-button>

      </ion-segment>

    </ion-toolbar>

  </ion-header>


  <ion-content class="page-content">


    <!-- LOADING -->

    <div *ngIf="loading" class="loading-container">

      <ion-spinner name="crescent">
      </ion-spinner>

      <p>
        Cargando publicidad...
      </p>

    </div>


    <!-- CONTENIDO -->

    <div *ngIf="!loading" class="content-container">


      <!-- INFORMACIÓN DE SECCIÓN -->

      <div class="section-header">

        <div>

          <h1>

            {{ selectedStatus === 'active'
            ? 'Publicidades activas'
            : 'Publicidades inactivas' }}

          </h1>

          <p>

            {{ selectedStatus === 'active'
            ? 'Estas publicidades se muestran actualmente en la aplicación.'
            : 'Estas publicidades están ocultas de la aplicación.' }}

          </p>

        </div>





        <!-- RESULTADOS -->

        <div class="results-count" *ngIf="displayedAdvertisings.length > 0">

          {{ displayedAdvertisings.length }}
          {{ displayedAdvertisings.length === 1
          ? 'resultado'
          : 'resultados' }}

        </div>

      </div>


      <!-- MENSAJE CUANDO ESTÁ ORDENANDO -->

      <div *ngIf="canReOrder" class="reorder-notice">

        <ion-icon name="swap-vertical-outline">
        </ion-icon>

        <span>
          Arrastra las publicidades para cambiar su orden.
        </span>

      </div>


      <!-- SIN RESULTADOS -->

      <div *ngIf="displayedAdvertisings.length === 0" class="empty-state">

        <div class="empty-icon">

          <ion-icon [name]="search ? 'search-outline' : 'megaphone-outline'">
          </ion-icon>

        </div>

        <h2>

          {{ search
          ? 'No encontramos resultados'
          : 'No hay publicidades' }}

        </h2>

        <p>

          {{ search
          ? 'Intenta utilizar otro término de búsqueda.'
          : selectedStatus === 'active'
          ? 'No existen publicidades activas actualmente.'
          : 'No existen publicidades inactivas actualmente.' }}

        </p>

        <ion-button *ngIf="search" fill="outline" size="small" (click)="clearSearch()">

          Limpiar búsqueda

        </ion-button>

      </div>


      <div *ngIf="canReOrder" class="save-order-container">

        <ion-button expand="block" color="success" (click)="saveOrder()">

          <ion-icon slot="start" name="save-outline">
          </ion-icon>

          Guardar orden

        </ion-button>

      </div>


      <!-- LISTADO -->

      <ion-list *ngIf="displayedAdvertisings.length > 0" class="item-list">

        <ion-reorder-group [disabled]="!canReOrder" (ionItemReorder)="doReorder($event)">


          <ion-item *ngFor="let advertising of displayedAdvertisings" class="list-item" lines="none">


            <!-- REORDER -->

            <ion-reorder *ngIf="canReOrder" slot="start">

            </ion-reorder>


            <!-- INFORMACIÓN -->

            <ion-label>

              <div class="title-row">

                <h2>
                  {{ advertising?.content }}
                </h2>


                <!-- ESTADO -->

                <ion-chip *ngIf="advertising?._status === 'active'" color="success" class="status-chip">

                  <ion-icon name="checkmark-circle">
                  </ion-icon>

                  <ion-label>
                    Activa
                  </ion-label>

                </ion-chip>


                <ion-chip *ngIf="advertising?._status === 'inactive'" color="medium" class="status-chip">

                  <ion-icon name="eye-off">
                  </ion-icon>

                  <ion-label>
                    Inactiva
                  </ion-label>

                </ion-chip>

              </div>


              <!-- TAGS -->

              <div class="tag-list" *ngIf="advertising?.theTags?.length">

                <ion-chip color="primary" outline="true" *ngFor="let tag of advertising?.theTags">

                  {{ tag?.name }}

                </ion-chip>

              </div>


              <!-- ORDEN -->

              <div class="item-order" *ngIf="canReOrder">

                Posición:
                <strong>
                  {{ advertising?.order + 1 }}
                </strong>

              </div>

            </ion-label>


            <!-- ACCIONES -->

            <ion-buttons slot="end" class="item-actions">


              <!-- EDITAR -->

              <ion-button fill="clear" class="action-button" (click)="openAdvertising(advertising, 'Editar')">

                <ion-icon slot="icon-only" name="create-outline">
                </ion-icon>

              </ion-button>


              <!-- ACTIVAR -->

              <ion-button *ngIf="advertising?._status === 'inactive'" fill="clear" color="success" class="action-button"
                (click)="activateAdvertising(advertising)">

                <ion-icon slot="icon-only" name="eye-outline">
                </ion-icon>

              </ion-button>


              <!-- DESACTIVAR -->

              <ion-button *ngIf="advertising?._status === 'active'" fill="clear" color="warning" class="action-button"
                (click)="deactivateAdvertising(advertising)">

                <ion-icon slot="icon-only" name="eye-off-outline">
                </ion-icon>

              </ion-button>


              <!-- ELIMINAR -->

              <ion-button fill="clear" color="danger" class="action-button" (click)="deleteAdvertising(advertising.id)">

                <ion-icon slot="icon-only" name="trash-outline">
                </ion-icon>

              </ion-button>

            </ion-buttons>


          </ion-item>

        </ion-reorder-group>

      </ion-list>


      <!-- GUARDAR ORDEN -->

      <div *ngIf="canReOrder" class="save-order-container">

        <ion-button expand="block" color="success" (click)="saveOrder()">

          <ion-icon slot="start" name="save-outline">
          </ion-icon>

          Guardar orden

        </ion-button>

      </div>

    </div>

  </ion-content>


  <!-- FOOTER -->

  <ion-footer>

    <ion-button expand="full" fill="clear" (click)="openAdvertising()">

      <ion-icon slot="start" name="add-outline">
      </ion-icon>

      Crear nueva publicidad

    </ion-button>

  </ion-footer>

</ion-app>